import React from 'react';
import { SignupGateModal } from '../auth/SignupGateModal';
import { useAuth } from '../../hooks/useAuth';
import { useSuppressTutorialTips } from '../../context/TutorialContext';

function GuestTransferGate({ children }) {
    const { isGuest, user } = useAuth();
    const [isDismissed, setIsDismissed] = React.useState(false);
    const shouldGate = isGuest === true || user?.isGuest === true;
    const isModalOpen = shouldGate && !isDismissed;

    useSuppressTutorialTips(isModalOpen);

    const handleDismiss = () => {
        setIsDismissed(true);
    };

    return (
        <>
            {children}
            <SignupGateModal
                open={isModalOpen}
                onDismiss={handleDismiss}
            />
        </>
    );
}

export { GuestTransferGate };
